import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Output,
  ViewChild,
} from '@angular/core';
import { ApplicationStep, providers } from "../nuvei-application-step";
import { DOCUMENT } from "@angular/common";
import { ModalBehavior, ModalsService } from "../../../../../../common/src/lib/services/modals.service";
import {
  ConfirmationDialog
} from "../../../../../../common/src/lib/modals/confirmation-dialog/confirmation-dialog.component";
import { PlacesService } from '../../../../../../common/src/lib/services/places.service';
import { Subscription } from "rxjs";
import { startWith } from "rxjs/operators";
import { NgControl } from "@angular/forms";

@Component({
  selector: 'app-nuvei-application-owners',
  templateUrl: './nuvei-application-owners.component.html',
  styleUrls: ['./nuvei-application-owners.component.scss'],
  providers
})
export class NuveiApplicationOwnersComponent extends ApplicationStep<'businessOwnersForm'> {

  @Output() addOwner = new EventEmitter();

  @ViewChild('guarantorInput') guarantorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('guarantorInput', {read: NgControl})
  guarantorInputDirective!: NgControl;

  fieldExplanations = [
    { id: 'name', title: 'First Name & Last Name', explanation: 'The legal first and last name of the business owner.' },
    { id: 'phoneAndEmail', title: 'Phone Number & Email', explanation: 'Contact details used for verification and communication.' },
    { id: 'title', title: 'Title', explanation: 'The owner’s role or position within the business.' },
    { id: 'ownershipPercentage', title: 'Ownership Percentage', explanation: 'The percentage of the business owned by this individual.' },
    { id: 'citizenshipAndBirthDate', title: 'Citizenship & Birth Date', explanation: 'Required for identity verification and compliance purposes.' },
    { id: 'ssn', title: 'Social Security Number (SSN)', explanation: 'Used for identity and financial verification.' },
    { id: 'address', title: 'Address', explanation: 'The owner’s residential address, used for background and compliance checks.' },
    { id: 'guarantor', title: 'Guarantor', explanation: 'A guarantor is an owner who takes financial responsibility for the business’s obligations and signs all required documents, including this form.\nMust be one of the owners.' },
  ];

  fieldToExplanations = {
    'firstName': 'name',
    'lastName': 'name',
    'phoneNumber': 'phoneAndEmail',
    'email': 'phoneAndEmail',
    'title': 'title',
    'ownershipPercentage': 'ownershipPercentage',
    'citizenship': 'citizenshipAndBirthDate',
    'birthDate': 'citizenshipAndBirthDate',
    'birthDateDatePicker': 'citizenshipAndBirthDate',
    'ssn': 'ssn',
    'address': 'address',
    'unit': 'address',
    'guarantor': 'guarantor',
  };

  owners: string[] = [];
  ownersFormSub?: Subscription;

  constructor(
      @Inject(DOCUMENT) protected document: Document,
      private modalsService: ModalsService,
      protected placesService: PlacesService,
  ) {
    super();
  }
  async ngAfterViewInit(): Promise<void> {
    await super.ngAfterViewInit();

    this.ownersFormSub = this.form.valueChanges.pipe(startWith(this.form.value)).subscribe(value => {
      if(value.owners && value.owners.length > 0) {
        this.owners = value.owners
            .filter(owner => !!owner.firstName || !!owner.lastName)
            .map((owner) => [owner.firstName, owner.lastName].filter(name => !!name).join(' '));
        if(this.form.controls.guarantor.value > this.owners.length - 1)
          this.form.controls.guarantor.setValue(0);

        this.onGuarantorSelected();
      }
    });
  }

  removeOwner(index: number) {
    this.modalsService.open(ConfirmationDialog, {
      behavior: ModalBehavior.Dialog,
      data: {
        title: 'Remove person',
        message: 'Are you sure you want to remove this person?',
        actionTitle: 'Yes',
        cancelTitle: 'No',
        action: () => {
          this.form.controls.owners.removeAt(index);
        }
      }
    })
  }

  // totalPercentage(index: number) {
  //   let total = this.form.controls.owners.controls.reduce((acc, curr) => {
  //     if(curr.controls.ownershipPercentage.value != null)
  //       acc += curr.controls.ownershipPercentage.value;
  //     return acc;
  //   }, 0);
  //   if(total > 100) {
  //     const control = this.form.controls.owners.controls[index].controls.ownershipPercentage;
  //     total -= control.value;
  //     control.setValue(100 - total);
  //   }
  // }

  onGuarantorSelected() {
    const index = this.form.controls.guarantor.value;
    const group = this.form.controls.owners.controls[index];
    if(!group) {
      this.form.controls.guarantor.setValue(0);
      return;
    }
    const name = [group.controls.firstName.value, group.controls.lastName.value].filter(name => !!name).join(' ');
    this.guarantorInputDirective.valueAccessor?.writeValue(name);
  }

  ngOnDestroy() {
    this.ownersFormSub?.unsubscribe();
    super.ngOnDestroy();
  }
}
